
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's02c72eca8096d52b': `Frequenz :`,
's061681af0ef72b5b': `Quelle : RCP`,
's07b491eb0576ebe7': `Häufig`,
's0a0128aa069c7079': `MEDIKAMENTE`,
's2275181e03237a7d': `Wählen Sie die Frequenz.`,
's239412ba24c41c3d': `NEBENWIRKUNGEN`,
's4f98e3dc95342d4b': `GERÄT`,
's5bc631044823f152': `Unbekannt`,
's66816dfbf0e7ecb1': `Wenig häufig`,
's6c4f34936917c922': `Wählen Sie die Anzeigeebene.`,
's6cac4d926f758862': `Sehr selten`,
's7ac2ed2b6e85c444': `Es gibt keine Nebenwirkungen mit folgenden Häufigkeiten: `,
's9834072bd350f59d': `Selten`,
's9cf567bc9eccb5b4': `Sehr häufig`,
's9dfd349c32ba726b': `Die Anzeigeebene zurücksetzen.`,
'scd2231ae377afdd4': `Aktuelle Anzeigeebene.`,
'se7692ace93a23c21': `Außergewöhnlich`,
'sf8cdcbf29ee05fbd': `Einzelne Fälle`,
    };
  